"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryContext = void 0;
const react_1 = require("react");
exports.HistoryContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=history-context.js.map